<template>
    <div class="my-info max-width-box">
        <!-- <div class="menu-box">
            <div class="avatar-box">
                <img class="my-info-avatar" :src="userInfo.photo?userInfo.photo:defaultAvatar"/>
                <div>{{userInfo.realname}}</div>
            </div>
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" @select="handleSelect">
                <el-menu-item v-for="item,index of myInfoRouter" :key="index" :index="item.path">
                    <div style="display:flex;justify-content:space-between;width:100%;">
                        <span class="real-title" :title="item.name">{{item.name}}</span>
                        <el-badge v-if="item.path.indexOf('messages')>0 && messageNum>0" class="mark" :value="messageNum" />
                        <el-badge v-if="item.path.indexOf('notification')>0 && notificationNum>0" class="mark" :value="notificationNum" />
                    </div>
                </el-menu-item>
            </el-menu>
        </div> -->

        <transition name="fadeInFn" mode="out-in">
            <div class="my-info-child">
                <router-view></router-view>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {myInfoRouter} from "@/utils/global";
export default {
    computed: {
        ...mapState({
            xToken: (state) => state.app.token,
            userInfo: (state) => state.app.userInfo,
            defaultAvatar:(state) => state.app.defaultAvatar,
            messageNum: (state) => state.app.messageNum,
            notificationNum: (state) => state.app.notificationNum,
        }),
    },
    data(){
        return{
            myInfoRouter:myInfoRouter,
            activeIndex:'profile'
        }
    },
    watch:{
        '$route.name':function(newVal,oldVal){
            this.initPage();
        }
    },
    mounted(){
        if(!this.xToken){
            this.$router.push({
                path:'/login',
                query:{
                    returnto:this.$route.fullPath
                }
            })
        }
        this.initPage();
    },
    methods:{
        initPage(){
            this.$store.commit('SET_CHILD_MENU_LIST',[
                {
                    id: '101',
                    name: 'My Schedule',
                    path: '/myinfo/classschedule'
                },
                {
                    id: '108',
                    name: 'My Wallet',
                    path: '/myinfo/wallet'
                },
                {
                    id: '111',
                    name: 'Account center',
                    path: '/myinfo/profile'
                },
            ])
            //当path改变时,避免二级菜单失去选中
            for(let item of myInfoRouter){
                if(this.$route.path.includes(item.path)){
                    this.activeIndex = item.path;
                    break
                }
            }
        },
        handleSelect(index){
            this.$router.push(index);
        }
    }
}
</script>
<style scoped lang="scss">
@import "~@/utils/vw.scss";
.my-info {
    height: auto;
    background: #F9F9F9;
    padding: 24px 0;
    display: flex;
    .menu-box{
        width: 240px;
        border-radius: 8px;
        margin-right: 32px;
        background: #fff;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
        .avatar-box{
            padding-top: 42px;
            text-align: center;
            .my-info-avatar{
                width: 96px;
                height: 96px;
                border-radius: 50%;
            }
            div{
                margin-top: 8px;
                height: 25px;
                font-size: 18px;
                font-weight: 600;
                color: #181D2C;
                line-height: 25px;
            }
        }
        .el-menu{
            margin-top: 60px;
        }
        .el-menu-item{
            padding: 12px 14px 12px 60px !important;
            // margin: 6px 0;
            height: 44px;
            line-height: 20px;
            font-weight: 600;
            &:hover{
                background: #fff8f0;
            }
            &:focus{
                background: #fff8f0;
            }
        }
        .el-menu-item.is-active{
            color: #F48C06;
            border-right: 2px solid #F48C06;
            padding: 12px 12px 12px 60px !important;
            
        }
    }
    .el-menu-demo{
        border-right: none;
        border-radius: 8px;
    }
    .my-info-child{
        width: 100%;
        height: auto;
    }
}
</style>